import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type {
    AsyncTaskData,
    ComponentBindLocateRequest,
    UpdateComponentBindLocateRequest,
    ComponentBindLocateResponseData,
} from '../component-bindlocate-api';
import type {
    NoveltyAiSearchApi,
    ComponentExtractBindLocateRequest,
    ComponentExtractBindLocateResponseData,
} from '../novelty-ai-search-api';
import { noveltyAiSearchApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class NoveltyAiSearchApiImpl
    extends PsHttpService
    implements NoveltyAiSearchApi {

    get options() {
        return {
            baseURL: noveltyAiSearchApiUrlPrefix,
        };
    }

    async componentExtractBindLocate(data: ComponentExtractBindLocateRequest): Promise<AsyncTaskData<ComponentExtractBindLocateResponseData>> {
        const result = await this.post<PatSnapSuccessResponseData<AsyncTaskData<ComponentExtractBindLocateResponseData>>>({
            url: 'component_extract_bindlocate',
            data,
            headers: {
                'x-result-id': data.task_id,
            },
        });
        return result.data;
    }

    async componentBindLocate(data: ComponentBindLocateRequest): Promise<AsyncTaskData<ComponentBindLocateResponseData>> {
        const result = await this.post<PatSnapSuccessResponseData<AsyncTaskData<ComponentBindLocateResponseData>>>({
            url: 'component_bindlocate',
            data,
        });
        return result.data;
    }

    async updateComponentBindLocate(data: UpdateComponentBindLocateRequest): Promise<ComponentBindLocateResponseData> {
        const result = await this.put<PatSnapSuccessResponseData<ComponentBindLocateResponseData>>({
            url: 'component_bindlocate',
            data,
        });
        return result.data;
    }
}
